import React from 'react';
import KpiDevToDonePanel from './KpiDevToDonePanel';
import azureDevOpsService from './services/azureDevOpsService';

export default function KpiBugDevToDoneTime() {
  return (
    <KpiDevToDonePanel
      title="Temps moyen Dev → Done (Bugs)"
      subtitle="Bugs · Tribu Argonos · de l'état 2-Dev à 6-Done"
      fetchFn={(start, end, sample) =>
        azureDevOpsService.getAverageBugDevToDoneTime(start, end, sample)
      }
    />
  );
}
